// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"318":"320f048ad850ada3ae40","669":"6921a9e529a11b67a8fd","795":"7f84e8b4e7d067387243","796":"d491e0b28aa207233f0a","820":"f0fcfc540b5f000c0ac5"}[chunkId] + ".js";
};